import { render, staticRenderFns } from "./EditDrug.vue?vue&type=template&id=1e70176c&scoped=true"
import script from "./EditDrug.vue?vue&type=script&lang=js"
export * from "./EditDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70176c",
  null
  
)

export default component.exports